<script>
export default {
  name: 'Popover',
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<template>
  <el-popover trigger="hover" placement="top">
    <span class="text-popover-show">{{ text }}</span>
    <div slot="reference">
      <span class="text-show">
        {{ text }}
      </span>
    </div>
  </el-popover>
</template>

<style scoped lang="scss">
.text-show {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: pre-line;
}
.text-popover-show {
  width: 200px !important;
  display: inline-block;
}
</style>
